<template>
  <div v-if="report">
    <Chat />

    <!-- Tipo Informe -->
    <ReportPowerBI
      v-if="report.tipoInforme == reportTypes.PowerBI"
      :report="report"
    />

    <!-- Tipo URL -->
    <ReportURL
      v-else-if="report.tipoInforme == reportTypes.URL"
      :report="report"
    />

    <!-- Tipo Tabla -->
    <ReportTable
      v-else-if="report.tipoInforme == reportTypes.Tabla"
      :report="report"
    />

    <!-- Tipo Gráfico -->
    <ReportChart
      v-else-if="report.tipoInforme == reportTypes.Grafico"
      :report="report"
    />

    <!-- Ningún tipo especificado -->
    <div v-else>No se ha especificado ningún tipo para el informe</div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { onMounted, ref, onUnmounted } from "vue";
import { useToast } from "primevue/usetoast";

import ReportPowerBI from "@/pages/_root/views/reports-details/ReportPowerBI.vue";
import ReportURL from "@/pages/_root/views/reports-details/ReportUrl.vue";
import ReportTable from "@/pages/_root/views/reports-details/ReportTable.vue"; // eslint-disable-line
import ReportChart from "@/pages/_root/views/reports-details/ReportChart.vue";
import Chat from "@/components/panels/Chat.vue";
import {
  userReportDetails,
  userReportAdditionalDetails,
  userReportAccessReport,
} from "@/api/reports/reports.api.js";
import { isLogged } from "@/composables/_commons/auth.js";
import { reportTypes } from "@/composables/_commons/enums.js";
import { toggleElements } from "@/composables/_commons/helper.js";

// #region Props, Emits
// #endregion

// #region  Params, Ref, Reactives, Computed
const toast = useToast();
const report = ref(null);
const router = useRouter();
const route = useRoute();
// #endregion

// #region Functions
onMounted(async () => {
  toggleElements(false, false);

  const reportAlias = route.params.alias;
  const response = await userReportDetails(reportAlias);

  if (response.status != 200) {
    const error = response?.response?.data?.errors?.[0]?.message;

    if (error) {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
    }

    router.push({
      name: "Public reports",
    });

    return;
  }

  const data = response.data;

  if ((await isLogged()) && data.idInforme) {
    userReportAccessReport({ idInforme: data.idInforme });
  }
  const additionalDetails = await userReportAdditionalDetails(data.alias);

  // push additional details to the report object
  report.value = { ...data, ...additionalDetails };

  const showElements =
    report.value.tieneCabecera == true || report.value.tieneCabecera == null;

  // Change title meta tag
  document.title = `Informe ${report.value.titulo}`;

  toggleElements(showElements, false);
});

onUnmounted(() => {
  toggleElements(true, true);
});
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>
